import _orderBy from 'lodash/orderBy';
// Serialization
import { deserialize } from 'serializr';
import { equipmentSchema } from './schemas';
// Custom
import { findInList } from '../utils/Tools';

/**
* Serialization
*/
const deserializeEquipment = (data) => deserialize(equipmentSchema, data);

/**
* Lists
*/
const equipmentTypesList = [
  {
    key: 'keypad',
    value: 'keypad',
    labelId: 'equipment.type.keypad',
    icon: 'equKeypad',
  },
  {
    key: 'license_plate_reader',
    value: 'license_plate_reader',
    labelId: 'equipment.type.license_plate_reader',
    icon: 'equLpr',
  },
  {
    key: 'rfid_reader',
    value: 'rfid_reader',
    labelId: 'equipment.type.rfid_reader',
    icon: 'equRfid',
  },
  {
    key: 'uhf_reader',
    value: 'uhf_reader',
    labelId: 'equipment.type.uhf_reader',
    icon: 'equUhf',
  },
];

/**
* Utils
*/
const sortEquipments = (equipments, fields = ['brand', 'model', 'protocol'], dirs = ['asc', 'asc', 'asc']) => (_orderBy(equipments, fields, dirs));

const equipmentType = (equipment) => findInList(equipmentTypesList, 'value', equipment, 'type');
const equipmentIsUsableForOnDemand = (equipment) => equipmentType(equipment).value === equipmentTypesList[1].value;

/**
* Model
*/
const equipment = {
  // Name
  name: 'equipment',

  // Serialization
  deserialize: deserializeEquipment,

  // Sort elements
  sortElements: sortEquipments,

  // Lists
  typesList: equipmentTypesList,
  isUsableForOnDemand: equipmentIsUsableForOnDemand,

  // Utils
  type: equipmentType,
};

module.exports = equipment;



// WEBPACK FOOTER //
// ./models/equipment.js